// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"1d351d2d","159":"c742736c","502":"91490732","671":"e2faa021","867":"70a95e84"}[chunkId] + ".chunk.css";
};